export default {
  name: ['资源名称', 'Resource Name'],
  name_zh_cn: ['中文为空', 'Chinese empty'],
  name_en_us: ['英文为空', 'English empty'],
  namePlaceholder: ['请输入资源名称', 'Please Enter Resource Name'],
  nameRequire: ['当前资源名称不能为空', 'Current route name cannot be empty'],
  key: ['资源控制键', 'Resource Key'],
  keyHelp: ['资源控制键即代表唯一标识也作用于路由', 'The resource control key means that the unique identifier also acts on the route'],
  keyPlaceholder: ['请输入资源控制键', 'Please Enter Resource Key'],
  keyRequire: ['当前资源控制键不能为空', 'Current Resource Key cannot be empty'],
  keyDuplicated: ['当前资源控制键已存在', 'Current Resource Key already exists'],
  parent: ['父级关联', 'Parent Key'],
  top: ['最高级', 'Top Level'],
  parentPlaceholder: ['请选择父级关联', 'Please Select Parent Key'],
  nav: ['是否为导航', 'Whether Navigate'],
  router: ['是否为路由', 'Whether Router'],
  policy: ['是否为策略节点', 'Whether Policy Node'],
  icon: ['字体图标', 'Icon Font']
};
